import React from 'react';
import { Card, HideOnTablet, HideOnMobile } from 'quanta-ui';
import QuoteSummaryDetails from './quoteSummaryDetails';

export default function QuoteSummaryPanel({
  productCode,
  lobCode,
  lobName,
  productName,
  quoteNumber,
  role,
  ...props
}) {
  return (
    <div className="flex flex-col justify-start h-auto sticky top-0">
      <HideOnMobile className="w-full">
        <HideOnTablet className="w-full">
          <Card
            className={`h-full xl:h-auto p-0 m-0`}
            title="Quotation"
          >
            {
              <QuoteSummaryDetails
                {...{
                  productCode,
                  productName,
                  lobCode,
                  lobName,
                  quoteNumber,
                  role,
                  customerDetailsFormRef:
                    props?.customerDetailsFormRef,
                  riskLocationFormRef: props?.riskLocationFormRef,
                }}
              />
            }
          </Card>
        </HideOnTablet>
      </HideOnMobile>
      <div className="xl:hidden w-full">
        {
          <QuoteSummaryDetails
            {...{
              productCode,
              lobCode,
              lobName,
              productName,
              quoteNumber,
              role,
              customerDetailsFormRef: props?.customerDetailsFormRef,
              riskLocationFormRef: props?.riskLocationFormRef,
            }}
          />
        }
      </div>
    </div>
  );
}
